import { useContext, createContext } from 'react'

export type AuthStatus = 'checking' | 'authenticated' | 'unauthenticated'

interface AuthContextValue {
  isAuthenticated: boolean
  status: AuthStatus
  setAuth: (
    authenticated: boolean,
    profile?: {
      displayName?: string | null
      email?: string | null
      tenantUrl?: string | null
      tenantId?: string | null
      isGlobalAdmin?: boolean
      baseStudioUrl?: string | null
      agentsContracted?: boolean
      studioRole?: 'Admin' | 'Editor' | null
      entitlementsAvailable?: boolean
    },
    reason?: 'expired' | 'logout' | 'authFailed'
  ) => void
  userEmail: string | null
  userName: string | null
  tenantUrl: string | null
  tenantId: string | null
  isGlobalAdmin: boolean
  baseStudioUrl: string | null
  agentsContracted: boolean
  studioRole: 'Admin' | 'Editor' | null
  /** See Profile.studioRolePending in AuthProvider. Optional so a test stub may
   * omit it — absent means "resolved". */
  studioRolePending?: boolean
  /** MS-866 AC6 — tri-state entitlements signal. False (and not pending) means
   * the entitlements lookup itself failed — see AuthProvider's Profile docs. */
  entitlementsAvailable: boolean
  /** See Profile.entitlementsPending in AuthProvider. Optional so a test stub
   * may omit it — absent means "resolved". */
  entitlementsPending?: boolean
  didLogOut: boolean
  didExpire: boolean
  didAuthFailed: boolean
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
